import { DiscountCoupon } from './discount-coupon';
import { GiftCard } from '../../giftcard/models/giftcard';

export class PrepaidPaymentInfo {
  private _discountCoupon: DiscountCoupon[];
  private _giftCards: GiftCard[];
  private _depositAmount: number;

  constructor (
    discountCoupon: DiscountCoupon[],
    giftCards: GiftCard[],
    depositAmount: number
  ) {
    this._discountCoupon = discountCoupon;
    this._giftCards = giftCards;
    this._depositAmount = depositAmount;
  }

  get discountCoupon(): DiscountCoupon[] {
    return this._discountCoupon;
  }

  get giftCards(): GiftCard[] {
    return this._giftCards;
  }

  get depositAmount(): number {
    return this._depositAmount;
  }

  get giftCardsAmount(): number {
    return GiftCard.getTotalCardsAmount(this._giftCards);
  }

  get discountCouponAmount(): number {
    return DiscountCoupon.getTotalDiscountCouponAmount(this._discountCoupon);
  }

  get totalCardsAmount(): number {
    return  this.giftCardsAmount + this.discountCouponAmount;
  }
}

